import "whatwg-fetch";
import { trim as _trim } from "lodash/string";
import { getCookie } from "tiny-cookie";

export function sendEmail(data, dic, config) {
  return window
    .fetch("/email", {
      credentials: "same-origin",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data,
        dic,
        config,
      }),
    })
    .then(async (response) => {
      if (response.status == 200) {
        return await response.json();
      } else {
        return Promise.reject(await response.json());
      }
    });
}

export const feildsDic = {
  _member_email: "email",
  form_name: "form_name",
  formname: "formname",
  utm_content: "utm_content",
  utm_campaign: "utm_campaign",
  utm_medium: "utm_medium",
  utm_source: "utm_source",
  utm_term: "utm_term",
  roistat: "roistat",
  referer: "referer",
  _ym_uid: "_ym_uid",
  yclid: "yclid",
  email: "email",
  users: "users",
  time: "time",
  date: "date",
  question: "question",
  phone: "phone",
  time_reply: "Когда удобно ответить",
  q183: "сфера деятельности",
  q697: "человек в команде",
  q284: "сотрудников в компании",
  name: "name",
  company: "company",
  tg: "tg",
  q259: "phone",
  refLinkId: "refLinkId",
  userId: "userId",
  q353: "phone",
  q346: "name",
  client_id: "client_id",
};

export const amoCrmPost = async (action, data) => {
  if (!action) return Promise.reject("form amoCrm hook is not defined");

  const amoCrmData = { comment: "" };

  for (const key in data) {
    if (Object.hasOwn(feildsDic, key)) {
      amoCrmData[feildsDic[key]] = data[key];
    } else {
      amoCrmData.comment += `${key}: ${data[key]} \n `;
    }
  }

  if (data.time_reply === "в ближайшее время") {
    amoCrmData.time = null;
    amoCrmData.date = null;
  }

  if (amoCrmData["сфера деятельности"] && data["formname"]) {
    const radioValue = [
      {
        title: "ИТ",
        value: 1,
      },
      {
        title: "Финансы",
        value: 2,
      },
      {
        title: "Страхование",
        value: 3,
      },
      {
        title: "Строительство",
        value: 4,
      },
      {
        title: "Производство",
        value: 5,
      },
      {
        title: "Ритейл",
        value: 6,
      },
      {
        title: "Проектное управление",
        value: 7,
      },
      {
        title: "Маркетинг и реклама",
        value: 8,
      },
      {
        title: "Другое",
        value: 9,
      },
    ];
    const tag =
      radioValue.find(
        (item) => `${item.value}` === amoCrmData["сфера деятельности"],
      )?.title || "Другое";
    amoCrmData[feildsDic["formname"]] = `${data["formname"]} ${tag}`;
  }

  return window
    .fetch("/amocrm", {
      credentials: "same-origin",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ action, data: amoCrmData }),
    })
    .then((response) => {
      return response.json();
    })
    .then(function (res) {
      return Promise.resolve({ key: "amocrm", res });
    })
    .catch(function (error) {
      return Promise.reject({ key: "amocrm", error });
    });
};

function isErrorStatus(res) {
  const sendsayErrorIds = Object.freeze({
    only_once: "Вы уже вводили данный email",
    no_mail: "Введен неверный email-адрес",
    form_not_active: "Сбор данных приостановлен",
    "error/email/badchar": "недопустимый символ в адресе",
    "error/email/dogdot": "недопустимое сочетание @. в адресе",
    "error/email/doghypen": "недопустимое сочетание @- в адресе",
    "error/email/dotatend": "точка на конце адреса не допустима",
    "error/email/dotdog": "недопустимое сочетание .@ в адресе",
    "error/email/dotdot": "недопустимое сочетание .. в имени хоста в адресе",
    "error/email/empty": "адрес пуст",
    "error/email/empty2": "адрес пуст",
    "error/email/longdomain": "слишком длинное имя хоста в адресе",
    "error/email/multydog": "несколько символов @ в адресе",
    "error/email/nodog": "адрес без символа @",
    "error/email/nohost": "не указано имя хоста в адресе",
    "error/email/nouser": "не указано имя ящика в адресе",
    "error/email/singleparthost": "в адресе имя хоста без точек",
    "error/email/toolong": "слишком длинный адрес",
    "error/email/wrongroot": "неверный домен верхнего уровня в адресе",
    "error/email/longmbox": "слишком длинное имя ящика в адресе",
  });
  const errStatus = ["Действие недоступно", "Required"];
  let isErr = false;
  if (!res) return isErr;
  if (res?.page) {
    errStatus.forEach((msg) => {
      if (res.page.indexOf(msg) != -1) {
        isErr = true;
      }
    });
  } else if (res?.errors) {
    isErr = true;
    const errorId = res.errors[0]?.id;
    isErr = sendsayErrorIds[errorId] || true;
    console.log("sendsay error status: ", errorId, isErr);
  }
  return isErr;
}

export const formSubmitHandler = async (action, data) => {
  if (!action)
    return Promise.reject("formSubmitHandler — form action is not defined");

  return window
    .fetch(action, {
      credentials: "same-origin",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      return response.json();
    })
    .then(function (res) {
      const explain = isErrorStatus(res);
      if (explain) {
        return Promise.reject(explain);
      }
      return Promise.resolve();
    })
    .catch((error) => {
      console.log("formSubmitHandler error: ", action, error);
      return Promise.reject("Ошибка сервера, попробуйте позже.");
    });
};

export function formUtmPrepare(form) {
  const FD = new FormData(form);
  const formDataObj = Object.fromEntries(FD);
  const urlParams = new URLSearchParams(window.location.search);

  const utmKeys = [
    "utm_source",
    "utm_campaign",
    "utm_medium",
    "utm_term",
    "utm_content",
    "yclid",
  ];
  utmKeys.forEach((utm) => {
    formDataObj[utm] = urlParams.get(utm);
    if (!formDataObj[utm]) {
      let cookieItem = "";
      const cookieKey = `_uc_${utm}`;
      try {
        cookieItem = getCookie(cookieKey);
      } catch {
        console.log(`getCookie(${cookieKey}) error`);
      }
      formDataObj[utm] = _trim(cookieItem);
    }
  });

  const roistatVisit = getCookie("roistat_visit");
  formDataObj["roistat"] = _trim(roistatVisit);
  formDataObj["referer"] = document.referrer;
  return formDataObj;
}
